/**
 *
 *  TruBe In Press
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 11-08-2024.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */
import React from "react";
import Slider from "react-slick";

// Icons
import ArrowLeftIcon from "../../icons/ArrowLeftIcon";
import ArrowRightIcon from "../../icons/ArrowRightIcon";

export const SliderPrevArrow = ({ className, style, onClick }) => (
  <button className={className} style={style} onClick={onClick}>
    <ArrowLeftIcon className="tbk-inline" />
  </button>
);

export const SliderNextArrow = ({ className, style, onClick }) => (
  <button className={className} style={style} onClick={onClick}>
    <ArrowRightIcon className="tbk-inline" />
  </button>
);

export const TruBeInPressSlider = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    useTransform: false,
    nextArrow: (
      <SliderNextArrow className="tbk-absolute tbk-top-1/2 tbk--left-2 tbk-rounded-full tbk-shadow-trube" />
    ),
    prevArrow: (
      <SliderPrevArrow className="tbk-absolute tbk-top-1/2 tbk--left-2 tbk-rounded-full tbk-shadow-trube" />
    ),
  };

  return (
    <Slider
      {...settings}
      className="tbk-relative tbk-touch-pan-y tbk-select-none lg:tbk-h-34"
    >
      <div>
        <div className="tbk-flex tbk-flex-col tbk-justify-evenly lg:tbk-grid lg:tbk-grid-cols-3 lg:tbk-gap-8">
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://techcrunch.com/2015/04/14/trube/?guccounter=1&amp;guce_referrer=aHR0cHM6Ly93d3cuZ29vZ2xlLmNvbS8&amp;guce_referrer_sig=AQAAANzWBmThbVS793oXi5rOjEo0tIC5bWsjuWwWvmOHr1c3RA7SSHAk66B_24IYHmdAWH15OYCpKG0bKNBvkCI8JWziTUzsGprFlMYUHZ56T5E4QausU4TzCn92hOGNVGpgS1mNM7a2jbkexO6BsMgcjRpYbUefZuiQnMbwnCLJZ_PP"
              target="_blank"
              className="tbk-mb-2 tbk-inline-block"
              rel="noreferrer"
            >
              <svg
                width="224"
                height="32"
                viewBox="0 0 224 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="tbk-mb-2"
              >
                <path
                  d="M41.8083 10.6667H62.7314V0H41.8083V10.6667Z"
                  fill="#0A9E01"
                />
                <path
                  d="M0 0V10.6667H10.4429V32H20.8858V10.6667H31.366V0H0Z"
                  fill="#0A9E01"
                />
                <path
                  d="M31.3657 31.9998H62.7317V21.3332H41.8086V10.6665H31.3657V31.9998Z"
                  fill="#0A9E01"
                />
                <path
                  d="M89.3992 8.05713H74.0332V12.4954H79.1801V26.4068H84.2523V12.4954H89.3992V8.05713Z"
                  fill="#0A9E01"
                />
                <path
                  d="M95.1795 12.3462C91.5618 12.3462 88.8765 14.7704 88.8765 19.5443C88.8765 23.7588 91.1515 26.7052 95.2914 26.7052C97.4546 26.7052 99.2075 26.1457 100.886 25.1387L99.0956 22.1178C97.7156 22.8264 96.7459 23.0874 95.5152 23.0874C94.2471 23.0874 93.352 22.4161 93.1655 20.887H101.259C101.296 20.6632 101.296 20.3648 101.296 19.9546C101.333 14.845 98.9837 12.3462 95.1795 12.3462ZM93.2401 17.9406C93.3893 16.5606 93.986 15.852 95.0676 15.852C96.4476 15.852 96.9324 16.5606 97.1562 17.9406H93.2401Z"
                  fill="#0A9E01"
                />
                <path
                  d="M110.284 22.8637C109.016 22.8637 108.345 21.7448 108.345 19.5443C108.345 17.3812 108.941 16.1504 110.172 16.1504C111.179 16.1504 111.627 16.7098 112.298 17.9406L115.543 15.4791C114.349 13.5397 112.857 12.3462 110.247 12.3462C105.846 12.3462 103.683 15.2553 103.683 19.4697C103.683 24.0944 106.107 26.6679 110.135 26.6679C112.559 26.6679 114.051 25.7355 115.655 23.3858L112.671 21.0362C111.776 22.3788 111.179 22.8637 110.284 22.8637Z"
                  fill="#0A9E01"
                />
                <path
                  d="M126.546 12.345C124.905 12.345 123.935 12.9045 123.077 13.5385V7.31006L118.341 9.21216V26.4429H123.077V18.5735C123.077 16.8578 123.674 16.373 124.681 16.373C125.651 16.373 126.248 16.8578 126.248 18.6108V26.4429H130.984V18.014C130.984 14.3963 129.53 12.345 126.546 12.345Z"
                  fill="#0A9E01"
                />
                <path
                  d="M142.359 22.266C140.158 22.266 139.263 20.0282 139.263 17.231C139.263 14.3219 140.195 12.196 142.321 12.196C144 12.196 144.634 13.2776 145.268 14.9932L149.892 13.1657C148.624 9.69721 146.834 7.75781 142.321 7.75781C137.398 7.75781 133.93 11.3382 133.93 17.231C133.93 22.6762 136.839 26.7042 142.284 26.7042C146.648 26.7042 148.699 24.3545 149.93 21.9676L145.641 19.6925C144.634 21.4082 143.962 22.266 142.359 22.266Z"
                  fill="#111418"
                />
                <path
                  d="M157.538 13.6516V12.6446H152.802V26.4068H157.538V18.9103C157.538 17.232 158.247 16.6725 159.403 16.6725C160.336 16.6725 161.007 17.1574 161.604 17.8287L162.722 12.9429C162.163 12.6073 161.492 12.3462 160.485 12.3462C159.254 12.3462 158.322 12.8683 157.538 13.6516Z"
                  fill="#111418"
                />
                <path
                  d="M172.829 20.514C172.829 22.2296 172.233 22.7145 171.263 22.7145C170.293 22.7145 169.697 22.2296 169.697 20.4767V12.6445H164.96V21.0734C164.96 24.6912 166.415 26.7051 169.435 26.7051C171.039 26.7051 172.046 26.1457 172.867 25.5117V26.4441H177.603V12.6818H172.867V20.514"
                  fill="#111418"
                />
                <path
                  d="M189.203 12.3462C187.562 12.3462 186.592 12.9056 185.734 13.5397V12.6073H180.998V26.3695H185.734V18.5C185.734 16.7844 186.331 16.2996 187.338 16.2996C188.308 16.2996 188.904 16.7844 188.904 18.5373V26.3695H193.641V17.9406C193.641 14.3975 192.224 12.3462 189.203 12.3462Z"
                  fill="#111418"
                />
                <path
                  d="M203.039 22.8637C201.771 22.8637 201.1 21.7448 201.1 19.5443C201.1 17.3812 201.696 16.1504 202.89 16.1504C203.897 16.1504 204.344 16.7098 205.016 17.9406L208.261 15.4791C207.067 13.5397 205.575 12.3462 202.965 12.3462C198.564 12.3462 196.4 15.2553 196.4 19.4697C196.4 24.0944 198.825 26.6679 202.853 26.6679C205.277 26.6679 206.769 25.7355 208.372 23.3858L205.389 21.0362C204.568 22.3788 203.934 22.8637 203.039 22.8637Z"
                  fill="#111418"
                />
                <path
                  d="M219.301 12.345C217.66 12.345 216.69 12.9045 215.832 13.5385V7.31006L211.096 9.21216V26.4429H215.832V18.5735C215.832 16.8578 216.429 16.373 217.436 16.373C218.406 16.373 219.002 16.8578 219.002 18.6108V26.4429H223.739V18.014C223.776 14.3963 222.322 12.345 219.301 12.345Z"
                  fill="#111418"
                />
              </svg>
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “Booking the trainer is the easy part. An on-demand ass-kicking is
              a few taps away”
            </p>
          </div>
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://thetimes.co.uk/article/the-best-apps-for-exercise-health-and-fitness-zqqkl3nmb"
              target="_blank"
              className="tbk-mb-2 tbk-inline-block"
              rel="noreferrer"
            >
              <img
                className="tbk-inline-block"
                alt="The Times"
                width="278px"
                height="32px"
                src="https://static.trubeapp.com/staging/assets/images/update/press/times-black.png"
                srcSet="https://static.trubeapp.com/staging/assets/images/update/press/times-black@2x.png 2x"
              />
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “The best apps for exercise, health and fitness”
            </p>
          </div>
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://womenshealthmag.com/uk/health/a702821/the-wellbeing-start-ups-on-our-radar/"
              target="_blank"
              className="tbk-inline-block"
              rel="noreferrer"
            >
              <svg
                width="157"
                height="32"
                viewBox="0 0 157 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="tbk-mb-2"
              >
                <path
                  d="M15.3001 31.7334L18.0583 3.74741C18.2144 2.31223 18.4746 2.07303 18.943 2.07303H19.2032V0.47839H14.7277V2.07303H15.0139C15.6384 2.07303 15.9506 2.52485 15.8726 3.74741L14.2853 20.4912L12.4639 3.74741C12.3077 2.44512 12.62 2.07303 13.3225 2.07303H13.4006V0.47839H7.15566V2.07303H7.46791C8.06638 2.07303 8.06638 2.31223 8.17047 3.74741L8.63884 8.02637L7.18168 21.5808L5.54239 3.77399C5.33422 2.33881 5.62045 2.09961 6.24494 2.09961H6.323V0.504969H0V2.09961H0.312246C0.962761 2.09961 1.0148 2.33881 1.17092 3.77399L3.98115 31.76H8.04036L9.62762 17.3816L11.2669 31.76C11.2669 31.7334 15.3001 31.7334 15.3001 31.7334ZM42.1794 13.395C42.1794 11.4549 42.1794 10.7638 43.3763 10.7638C44.209 10.7638 44.209 11.0828 44.209 12.704V29.3946C44.209 30.0059 44.0008 30.1122 43.6886 30.1122H43.5064V31.7068H49.8034V30.1122H49.5172C49.1009 30.1122 48.9708 29.9527 48.9708 29.3149V11.8269C48.9708 8.95658 48.3723 7.84033 45.6141 7.84033C44.0008 7.84033 42.8559 8.37188 42.1013 10.1526C41.7891 8.55792 40.9564 7.84033 38.8227 7.84033C37.0533 7.84033 36.1166 8.39846 35.4401 10.1526V7.84033L30.0538 8.29215V9.88679H30.288C30.6523 9.88679 30.9125 10.1526 30.9125 11.0562V29.2086C30.9125 29.9262 30.7563 30.1388 30.288 30.1388H30.0538V31.7334H36.0645V30.1388H35.8304C35.5181 30.1388 35.4401 30.0059 35.4401 29.5275V13.395C35.4401 11.4549 35.388 10.7638 36.611 10.7638C37.4436 10.7638 37.4436 11.0828 37.4436 12.704V29.3946C37.4436 30.0059 37.2615 30.1122 36.9753 30.1122H36.7151V31.7068H42.8819V30.1122H42.7779C42.3615 30.1122 42.1794 29.9527 42.1794 29.3149V13.395ZM86.1021 31.7334H93.6481V30.1388H93.1277C92.4772 30.1388 92.269 29.8464 92.269 28.4644V16.4248H96.2502V28.4644C96.2502 29.8464 96.068 30.1388 95.4175 30.1388H94.819V31.7334H102.313V30.1388H101.688C101.012 30.1388 100.908 29.8464 100.908 28.4644V3.74741C100.908 2.31223 101.012 2.07303 101.688 2.07303H102.313V0.47839H94.819V2.07303H95.4175C96.042 2.07303 96.2502 2.31223 96.2502 3.74741V14.5378H92.269V3.74741C92.269 2.31223 92.4512 2.07303 93.1277 2.07303H93.6481V0.47839H86.1021V2.07303H86.7787C87.4032 2.07303 87.6114 2.31223 87.6114 3.74741V29.2617C87.6114 29.9527 87.4292 30.1388 86.7787 30.1388H86.1021V31.7334ZM143.009 31.7334H148.968V30.1388H148.786C148.395 30.1388 148.343 30.0059 148.343 29.5275V13.395C148.343 11.4549 148.395 10.7638 149.592 10.7638C150.477 10.7638 150.477 11.0828 150.477 12.704V29.3946C150.477 30.0059 150.321 30.1122 150.061 30.1122H149.775V31.7068H156.098V30.1122H155.837C155.395 30.1122 155.317 29.9527 155.317 29.3149V11.8269C155.317 8.95658 154.614 7.84033 151.882 7.84033C150.087 7.84033 149.072 8.39846 148.343 10.1526V0L142.619 0.47839V2.07303H143.217C143.608 2.07303 143.842 2.31223 143.842 3.18929V29.2086C143.842 29.9262 143.712 30.1388 143.217 30.1388H143.009V31.7334ZM23.7308 31.9992C28.7267 31.9992 29.4293 27.7468 29.4293 19.9331C29.4293 12.0927 28.6747 7.86691 23.7308 7.86691C18.7869 7.86691 18.0323 12.0927 18.0323 19.9331C18.0323 27.7468 18.7348 31.9992 23.7308 31.9992ZM61.5387 31.7334H67.5495V30.1388H67.2632C66.925 30.1388 66.925 30.0059 66.925 29.5275V13.395C66.925 11.4549 66.925 10.7638 68.174 10.7638C69.0326 10.7638 69.0847 11.0828 69.0847 12.704V29.3946C69.0847 30.0059 68.8505 30.1122 68.6163 30.1122H68.3301V31.7068H74.6531V30.1122H74.3929C73.9505 30.1122 73.8464 29.9527 73.8464 29.3149V11.8269C73.8464 8.95658 73.1699 7.84033 70.4117 7.84033C68.6683 7.84033 67.6015 8.39846 66.951 10.1526V7.84033L61.1744 8.29215V9.88679H61.7989C62.1632 9.88679 62.4234 10.1526 62.4234 11.0562V29.2086C62.4234 29.9262 62.2673 30.1388 61.7989 30.1388H61.5647L61.5387 31.7334ZM116.937 31.9992C119.018 31.9992 119.773 30.9627 120.215 29.7401C120.605 31.574 121.048 31.9992 123.364 31.9992C126.096 31.9992 126.46 30.3248 126.408 27.0558H125.107C125.107 29.4212 125.055 29.6604 124.639 29.6604C124.248 29.6604 124.248 29.4743 124.248 28.1455V12.6508C124.248 9.51471 123.234 7.86691 119.643 7.86691C116.806 7.86691 113.97 8.74396 114.126 11.8801C114.204 13.3153 114.751 14.8302 116.234 14.7505C117.587 14.6707 118.212 13.9266 118.212 12.7572C118.212 11.9598 117.613 10.631 116.702 9.91337C117.041 9.7539 117.587 9.59444 118.498 9.59444C119.513 9.59444 119.695 10.3918 119.695 11.9067V16.2388C114.517 18.0461 113.424 18.7636 113.424 25.408C113.45 30.2185 114.595 31.9992 116.937 31.9992ZM107.985 31.9992C111.837 31.9992 112.747 30.8032 112.539 24.2652H110.952C110.952 29.4478 110.796 29.8464 109 29.8464C106.867 29.8464 106.867 28.8896 106.867 20.0128V19.2952H113.112C113.112 10.3386 112.149 7.86691 108.011 7.86691C104.265 7.86691 102.313 10.2323 102.313 20.0925C102.287 29.5009 103.77 32.0523 107.985 31.9992ZM56.1264 31.9992C59.9254 31.9992 60.9663 30.8032 60.8101 24.2652H59.2229C59.2229 29.4478 58.9887 29.8464 57.1412 29.8464C54.8254 29.8464 54.9555 28.8896 54.9555 20.0128V19.2952H60.9923C60.9923 10.3386 60.1856 7.86691 56.1004 7.86691C52.3274 7.86691 50.3759 10.2323 50.3759 20.0925C50.3759 29.5009 51.859 32.0523 56.1264 31.9992ZM127.267 31.7334H133.512V30.1388H133.043C132.653 30.1388 132.497 29.9261 132.497 29.2883V0L126.694 0.47839V2.07303H127.371C127.761 2.07303 127.917 2.2325 127.917 2.87036V29.368C127.917 29.9527 127.865 30.1388 127.605 30.1388H127.293L127.267 31.7334ZM81.6786 31.9992C84.5409 31.9992 86.0241 30.0856 86.0241 27.2153C86.0241 20.4912 80.0393 16.5843 80.0393 11.7472C80.0393 10.2589 80.5598 9.83364 81.5746 9.83364C83.0577 9.83364 83.2919 10.4715 83.5521 12.7306L83.7863 14.9631H85.5037V8.02637H84.1506C84.0725 8.90343 83.8904 9.22235 83.7863 9.11604C83.37 8.61107 82.3552 7.84033 80.6638 7.84033C78.1659 7.84033 75.9801 8.98316 75.9801 12.7837C75.9801 18.6839 81.9128 23.1755 81.9128 27.6936C81.9128 29.6338 81.4965 29.9527 80.1174 29.9527C78.7643 29.9527 78.4 29.3149 78.1398 26.3648L77.9317 24.3981H76.1363V31.7068H77.6975C77.8276 30.9095 78.0878 30.4045 78.322 30.6172C78.8424 31.255 79.3888 31.9992 81.6786 31.9992ZM134.683 26.79C134.683 30.564 135.229 31.9992 138.898 31.9992C141.474 31.9992 142.072 30.9627 142.072 28.0657V24.1057H140.511V28.2518C140.511 29.6338 140.381 29.7933 139.887 29.7933C139.366 29.7933 139.262 29.6338 139.262 28.4112V9.83364H142.098V8.02637H139.288V2.04646H137.701C136.556 7.36194 135.593 8.02637 134.058 8.02637H133.642V9.78048H134.683V26.79ZM23.7308 29.9527C22.6379 29.9527 22.6379 29.3149 22.6379 19.9065C22.6379 10.4715 22.6379 9.83364 23.7308 9.83364C24.8236 9.83364 24.8236 10.4715 24.8236 19.9065C24.8236 29.368 24.8236 29.9527 23.7308 29.9527ZM75.1995 9.03632C79.1026 6.08622 79.8832 3.85372 78.5822 1.80726C77.8796 0.691009 76.2664 -0.0265798 75.0954 0.956784C73.6903 2.15277 74.0286 4.22581 76.6567 5.42179C76.1883 5.97991 75.0954 7.06959 74.1847 7.97322L75.1995 9.03632ZM118.81 29.2086C117.873 29.2086 117.873 28.2252 117.873 25.0625C117.873 19.3218 117.873 18.551 119.747 17.5145V27.3481C119.747 28.8631 119.539 29.2086 118.81 29.2086ZM54.9555 17.6208C55.0336 10.1526 55.1637 9.80706 56.1785 9.80706C57.1412 9.80706 57.0892 10.2057 57.0892 17.6208H54.9555ZM106.867 17.6208C106.997 10.1526 107.049 9.80706 108.064 9.80706C109.078 9.80706 108.922 10.2057 108.922 17.6208H106.867Z"
                  fill="black"
                />
              </svg>
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “Like Uber for personal trainers”
            </p>
          </div>
        </div>
      </div>

      <div>
        <div className="tbk-flex tbk-flex-col tbk-justify-evenly lg:tbk-grid lg:tbk-grid-cols-3 lg:tbk-gap-8">
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://esquire.com/uk/life/fitness-wellbeing/g30150198/best-health-fitness-apps/"
              target="_blank"
              className="tbk-mb-2 tbk-inline-block"
              rel="noreferrer"
            >
              <img
                className="tbk-inline-block"
                alt="Esquire"
                width="120px"
                height="32px"
                src="https://static.trubeapp.com/staging/assets/images/update/press/esquire-logo.png"
                srcSet="https://static.trubeapp.com/staging/assets/images/update/press/esquire-logo@2x.png 2x"
              />
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “Best for: last-minute PT sessions”
            </p>
          </div>
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://forbes.com/sites/leebelltech/2019/01/02/best-health-and-fitness-apps-2019/?sh=78588bacca53"
              target="_blank"
              className="tbk-mb-2 tbk-inline-block"
              rel="noreferrer"
            >
              <img
                className="tbk-inline-block"
                alt="Forbes"
                width="120px"
                height="32px"
                src="https://static.trubeapp.com/staging/assets/images/update/press/forbes-logo.png"
                srcSet="https://static.trubeapp.com/staging/assets/images/update/press/forbes-logo@2x.png 2x"
              />
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “Best Health And Fitness Apps 2019”
            </p>
          </div>
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://harpersbazaar.com/uk/beauty/fitness-wellbeing/news/g38035/best-mum-baby-exercise-classes/"
              target="_blank"
              className="tbk-mb-2 tbk-inline-block"
              rel="noreferrer"
            >
              <img
                className="tbk-inline-block"
                alt="Bazaar"
                width="129px"
                height="32px"
                src="https://static.trubeapp.com/staging/assets/images/update/press/bazaar-logo.png"
                srcSet="https://static.trubeapp.com/staging/assets/images/update/press/bazaar-logo@2x.png 2x"
              />
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “Postnatal PT with TruBe”
            </p>
          </div>
        </div>
      </div>

      <div>
        <div className="tbk-flex tbk-flex-col tbk-justify-evenly lg:tbk-grid lg:tbk-grid-cols-3 lg:tbk-gap-8">
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://standard.co.uk/esmagazine/how-to-live-like-a-millennial-millionaire-a3689661.html"
              target="_blank"
              className="tbk-mb-2 tbk-inline-block"
              rel="noreferrer"
            >
              <img
                className="tbk-inline-block"
                alt="Evening Standard"
                width="246px"
                height="32px"
                src="https://static.trubeapp.com/staging/assets/images/update/press/evening-standard-logo.png"
                srcSet="https://static.trubeapp.com/staging/assets/images/update/press/evening-standard-logo@2x.png 2x"
              />
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “It’s the international jetsetter’s workout of choice”
            </p>
          </div>
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0">
            <a
              href="https://cosmopolitan.com/uk/body/health/a35271/new-health-companies/"
              target="_blank"
              className="tbk-mb-2 tbk-inline-block"
              rel="noreferrer"
            >
              <svg
                width="167"
                height="32"
                viewBox="0 0 167 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="tbk-mb-2"
              >
                <path
                  d="M9.20161 1.11084C5.06716 1.11084 1.77515 5.05491 1.77515 16.0003C1.77515 25.4149 3.62187 30.8882 9.20161 30.8882C15.3036 30.8882 16.0258 24.8522 16.0258 19.8635L11.6102 19.6612C11.5285 23.8065 11.1284 26.4605 9.40186 26.4605C7.79639 26.4605 7.23532 25.4154 7.23532 16.0008C7.23532 6.26213 8.31685 5.53696 9.40186 5.53696C10.6859 5.53696 11.2876 7.30796 11.2876 12.0574L15.9438 11.896C15.9438 6.66507 15.2215 1.11084 9.20161 1.11084ZM24.0413 1.11136C19.4268 1.11136 16.4156 4.69321 16.4156 16.0008C16.4156 27.3068 19.4268 30.8887 24.0413 30.8887C28.6566 30.8887 31.6675 27.3066 31.6675 16.0008C31.6675 14.4366 31.6078 13.0253 31.4963 11.7458C33.2928 17.7547 40.5706 19.2054 40.5706 23.6854C40.5706 24.8523 39.9688 26.4606 38.242 26.4606C35.994 26.4606 35.994 23.6455 35.994 22.0355V22.0349H31.3378C31.3378 25.9799 32.4631 30.8882 38.0423 30.8882C41.1094 30.8882 43.234 29.3937 44.3391 27.1348V30.3253H48.1932V9.32049H48.2727L51.7651 30.3253H54.6546L58.1878 9.32049H58.2683V30.3253H62.9239V16.5499C63.0215 27.4188 66.0068 30.8887 70.546 30.8887C74.7043 30.8887 77.5591 27.9781 78.0841 19.1341V30.3253H83.3017V18.8572H85.3898C89.2071 18.8572 91.268 16.7541 91.9913 13.3865C91.9519 14.2095 91.9296 15.0769 91.9296 16.0008C91.9296 27.3068 94.9404 30.8887 99.5548 30.8887C104.172 30.8887 107.183 27.3066 107.183 16.0008C107.183 4.6932 104.172 1.11135 99.5548 1.11135C95.8751 1.11135 93.217 3.39414 92.2904 10.0509C92.2251 4.00149 89.1403 1.67579 83.3017 1.67579H78.0841V12.867C77.5591 4.02172 74.7043 1.11135 70.546 1.11135C66.0068 1.11135 63.0215 4.58135 62.9239 15.4517V1.67579H56.1399L53.6916 16.3619H53.6121L51.2831 1.67579H44.3391V8.01692C43.8538 3.86594 41.9594 1.11135 37.842 1.11135C33.4735 1.11135 31.149 4.53869 31.0999 8.78006C30.0229 3.09934 27.4775 1.11135 24.0413 1.11135V1.11136ZM107.294 1.6758V30.3253H119.176V25.8987H112.513V1.6758H107.294ZM120.012 1.6758V30.3253H125.23V1.6758H120.012ZM126.107 1.6758V6.10193H130.603V30.3253H135.821V6.10193H140.258L136.865 30.3253H141.24L141.962 23.9673H146.179L146.939 30.3253H151.674H151.958H156.089V12.9814H156.169L161.749 30.3253H165.802V1.6758H161.629V16.8043H161.549L156.773 1.6758H151.674V28.0241L148.424 1.6758H140.879L140.316 5.69175V1.6758H126.107ZM24.0413 5.53696C25.2463 5.53696 25.9678 6.78469 25.9678 12.9814V19.0181C25.9678 25.2146 25.2463 26.4605 24.0413 26.4605C22.8363 26.4605 22.1142 25.2146 22.1142 19.0181V12.9814C22.1142 6.78469 22.8363 5.53696 24.0413 5.53696ZM37.7198 5.53696C39.8073 5.53696 39.8073 8.23357 39.8073 9.84356H44.3391V18.9318C41.9854 13.9358 35.754 12.1031 35.754 8.15331C35.754 6.58385 36.4767 5.53696 37.7198 5.53696ZM70.546 5.53696C71.7492 5.53696 72.472 6.78469 72.472 12.9814V19.0181C72.472 25.2146 71.7492 26.4605 70.546 26.4605C69.3418 26.4605 68.6189 25.2146 68.6189 19.0181V12.9814C68.6189 6.78469 69.3418 5.53696 70.546 5.53696ZM99.5553 5.53696C100.761 5.53696 101.482 6.78469 101.482 12.9814V19.0181C101.482 25.2146 100.761 26.4605 99.5553 26.4605C98.3519 26.4605 97.6293 25.2146 97.6293 19.0181V12.9814C97.6293 6.78469 98.3519 5.53696 99.5553 5.53696ZM83.344 6.10191H83.743C85.4692 6.10191 87.0753 6.22211 87.0753 10.3671C87.0753 13.8272 85.9109 14.6732 83.7837 14.6732H83.344V6.10191ZM144.129 6.10191H144.21L145.734 19.7833H142.486L144.129 6.10191Z"
                  fill="#EC008C"
                />
              </svg>
            </a>
            <p className="tbk-text-main tbk-mb-1.5 tbk-grow tbk-text-grey-main">
              “5 new health companies we're totally obsessed with”
            </p>
          </div>
          <div className="tbk-mb-7 tbk-inline-flex tbk-w-full tbk-flex-col lg:tbk-mb-0" />
        </div>
      </div>
    </Slider>
  );
};

export const TruBeInPress = () => (
  <div className="tbk-overflow-hidden tbk-bg-basic-white tbk-pt-5 tbk-pb-24 lg:tbk-mb-0 lg:tbk-pt-9 lg:tbk-pb-0">
    <div className="tbk-container tbk-mx-auto tbk-px-2 tbk-pb-1 lg:tbk-px-8 lg:tbk-pb-24">
      <div className="tbk-relative tbk-mb-6 tbk-text-center">
        <h3 className="tbk-text-h3-subtitle lg:tbk-text-title-bold tbk-inline-block tbk-bg-basic-white tbk-px-2 tbk-text-center tbk-text-blue-grey">
          TruBe in Press
        </h3>
        <hr className="tbk-mb-0 tbk--mt-1.5 tbk-border-blue-grey-light lg:tbk--mt-2" />
      </div>

      {/*<div className="tbk-relative tbk-mt-1 tbk-mb-6 lg:tbk-mb-8 lg:tbk-mt-1">*/}
      {/*  <div className="tbk-bg-basic-white tbk-py-0 tbk-pr-2 lg:tbk-pl-2">*/}
      {/*    <div className="tbk-text-h2-black lg:tbk-text-extra-bold tbk-inline-block tbk-text-grey-main">*/}
      {/*      Word on <span className="tbk-text-coral">the Street</span>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  /!*<hr className="tbk-mx-auto tbk-mb-0 tbk--mt-[18px] tbk-border-blue-grey-light" />*!/*/}
      {/*</div>*/}

      <TruBeInPressSlider />
    </div>
  </div>
);

export default TruBeInPress;
